<template>
    <transition appear name='slide-down'>
        <header>
            <template v-if="!hide_search">
                <input class="search" type="text" name="search" placeholder="Suchen..." v-model="query">
            </template>

            <img @click="goHome()" src="@/assets/images/logo.svg" class="logo"></img>
            <img src="@/assets/images/closeIcon.svg" class="close"></img>
        </header>
    </transition>
</template>

<script>
export default {
    //props: ['hide_search'],
    data() {
        return {
            query: this.$shared.query,
        };
    },
    mounted() {
        this.$shared.sync(this, 'query');
    },
    computed: {
        hide_search() {
            /*
            return ['announcements', 'applicant-with-id', 'employer-with-id', 'login', 'registration', 'forgot-password'].indexOf(this.$route.name) !== -1;
            */
            return ['employers', 'applicants'].indexOf(this.$route.name) === -1;
        },
    },

    methods: {
      goHome() {
        this.$router.push("/me")
      }
    }
}
</script>

<style scoped lang="scss">
    
header {
  position: fixed;
  top: 0pt;
  left: 0pt;
  width: 100vw;
  background-color: $light-bg-color;
  padding: 0.9em 1.3em;
  -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  -ms-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  z-index: 3;
  display: flex;
  justify-content: flex-end;
  /*flex-direction: row-reverse;*/ }
  header .logo {
    display: block;
    width: calc(100% - 6em);
    max-width: 14em;
    -webkit-transition: all 0.2s;
    -moz-transition: all 0.2s;
    -ms-transition: all 0.2s;
    transition: all 0.2s;
    position: absolute;
    cursor: pointer;
    top: 50%;
    left: 1.5em;
    transform: translateY(-50%); }
  header .close {
    height: 12pt;
    width: 0pt;
    padding: 0pt;
    margin: 0pt;
    opacity: 0;
    cursor: pointer;
    margin: 6pt 0pt; }
  header .search {
    background-color: rgba(206, 216, 217, 0.28);
    display: block;
    border: none;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    -ms-border-radius: 3px;
    border-radius: 3px;
    -webkit-transition: all 0.2s;
    -moz-transition: all 0.2s;
    -ms-transition: all 0.2s;
    transition: all 0.2s;
    width: 17em;
    margin: 0pt;
    height: 24pt;
    padding: 0pt 8pt 0pt 24pt;
    color: #4B4F4F;
    outline: none;
    background-image: url(/static/images/lupe.svg);
    background-position: 10px center;
    background-repeat: no-repeat;
    background-size: 12pt 12pt; }
  header .search::placeholder {
    color: #4B4F4F;
    font-family: Nunito;
    /*letter-spacing : 1.08px;*/ }
  header .search:focus {
    padding: 0pt 8pt;
    background-position: -20px center; }

@media (max-width: 390pt) {
  header {
    /* Firefox < 19 */
    /* Firefox > 19 */
    /* Internet Explorer 10 */ }
    header .search {
      width: 0pt;
      background-color: inherit;
      cursor: pointer;
      padding-right: 0pt; }
    header .search:focus {
      cursor: text;
      width: 100%;
      background-color: rgba(206, 216, 217, 0.28);
      z-index: 3;
      position: relative;
      padding-right: 4pt; }
    header .search:focus ~ .logo {
      opacity: 0; }
    header .search:focus ~ .close {
      width: 12pt;
      opacity: 1;
      margin: 6pt 0pt 6pt 16pt; }
    header input::-webkit-input-placeholder {
      opacity: 0; }
    header input:focus::-webkit-input-placeholder {
      opacity: 1; }
    header input:-moz-placeholder {
      opacity: 0; }
    header input:focus:-moz-placeholder {
      opacity: 1; }
    header input::-moz-placeholder {
      opacity: 0; }
    header input:focus::-moz-placeholder {
      opacity: 1; }
    header input:-ms-input-placeholder {
      opacity: 0; }
    header input:focus:-ms-input-placeholder {
      opacity: 1; } }


</style>


// WEBPACK FOOTER //
// src/components/header.vue